import UrgentCarePlatform from "@/components/UrgentCarePlatform";

export default function UrgentCare() {
  return (
    <div
      className="min-h-screen font-sans"
      style={{
        backgroundImage: "url('/assets/shared/simple-bg.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        fontFamily: "Montserrat, system-ui, sans-serif",
      }}
    >
      <main>
        <UrgentCarePlatform />
      </main>
    </div>
  );
}
